import { render, staticRenderFns } from "./ld.vue?vue&type=template&id=c979bda6&"
import script from "./ld.vue?vue&type=script&lang=js&"
export * from "./ld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports